import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptOrderThunk,
  fetchOrderPrintDetails,
  setShowOrderInfosModal,
} from "../store/actions/ordersSlice";
import { dispatchSnackBarMessage } from "../utils/snackbar";
import { ERROR_QZ_TRAY_REQUIRED } from "../common/helpersTxt";

const useOrderOperations = () => {
  const dispatch = useDispatch();
  const showOrderInfosModal = useSelector(
    (state) => state.orders.showOrderInfosModal
  );

  const handleOrderDetails = useCallback(
    (order) => {
      dispatch(
        setShowOrderInfosModal({
          orderId: order.order_id,
          show: !showOrderInfosModal,
        })
      );
    },
    [dispatch, showOrderInfosModal]
  );

  const handleAcceptOrder = useCallback(
    (order) => {
      dispatch(acceptOrderThunk({ order }));
    },
    [dispatch]
  );

  const handlePrintOrder = useCallback(
    async (orderId, e) => {
      try {
        e.stopPropagation();
        await dispatch(fetchOrderPrintDetails({ orderId })).unwrap();
      } catch (error) {
        console.error("Failed to print order:", error);
        dispatchSnackBarMessage(
          `dashboard-orders-list-print-${new Date()}`,
          ERROR_QZ_TRAY_REQUIRED,
          "error"
        );
      }
    },
    [dispatch]
  );

  const getOrdersArray = (ordersState) => {
    if (!ordersState || !ordersState.ids || !ordersState.entities) {
      return [];
    }

    return ordersState.ids.map((id) => ordersState.entities[id]);
  };

  return {
    handleOrderDetails,
    handleAcceptOrder,
    handlePrintOrder,
    getOrdersArray,
  };
};

export default useOrderOperations;
